import React, { useEffect } from 'react';
import { Box, Grid, Stack, TextField, Typography } from '@mui/material'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
import 'chartjs-adapter-date-fns';
import { Bar, Line } from 'react-chartjs-2';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';


import { dailyActiveUserGraphAction } from '../../redux/toolkit/dashboard/dailyActiveUserGraph';


ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

export const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' 
      },
      
    },
  };

  const p_Properties = {
fontWeight: "500",
    paddingBlock: "10px",
    fontSize: "16px",
    display: "flex",
    color: "rgba(47, 52, 62, 1)",
  };




const DailyActiveUserChart = () => {
    const dispatch = useDispatch()
    const dailyActive = useSelector(state => state.dailyActiveUser)
    const labels = [];
    const userCount = [];


    dailyActive?.data.map(item => {
        labels.push(item?._id)
        userCount.push(item?.count)
    })


    const [date, setDate] = React.useState(dayjs());

    const onDateChangeHandler = (date) => {
        setDate(date)
    };

    const submitHandler = (e) => {

        const startDate = new Date(date.$d)
        startDate.setHours(startDate.getHours() + 5);
        startDate.setMinutes(startDate.getMinutes() + 30);
        const newValue = startDate.toISOString()
        const query = {}
        query.date = newValue;
        query.days = e.target.value
        dispatch(dailyActiveUserGraphAction())
    }




    const data = {
        labels,
        datasets: [
            {
                label: 'Users Count',
                data: userCount,
                backgroundColor: 'rgba(138, 180, 117, 1)',
                tension: 0.4,

            },
        ],
    };

   


    useEffect(() => {

        const startDate = new Date(date.$d)
        startDate.setHours(startDate.getHours() + 5);
        startDate.setMinutes(startDate.getMinutes() + 30);
        const newValue = startDate.toISOString()
        const query = {}
        query.date = newValue;
        query.days = 7;
        dispatch(dailyActiveUserGraphAction())
    }, [dispatch])
    return (
        <Stack flexDirection={"row"}>
             

            <Grid item xs={10}>
            <Typography sx={p_Properties} variant="p">
            DAUs (Daily Active Users)
              </Typography>
              <Box sx={{
                width:"100%",
                height:"1px",
                background:"rgba(217, 217, 217, 1)"


              }}/>
              <br/>
              <br/>
                <Bar options={options} data={data} /></Grid>
           
        </Stack>


    );
}

export default DailyActiveUserChart
